import { useAppToast } from "@/hooks/useAppToast";
import { BoxProps, Button, Divider, Flex, Text } from "@chakra-ui/react";
import { AppForm, FormField, Link } from "@picovico/ui";
import { parseApiError } from "@picovico/utils";
import { useForgotPasswordMutation } from "@store/services/auth";
import { isString } from "lodash";
import { useRouter } from "next/router";
import * as yup from "yup";

export interface forgotPasswordValues {
  email: string;
}

const forgotPasswordFormValidationSchema = yup.object().shape({
  email: yup.string().email().required().label("Email"),
});

const initialValues: forgotPasswordValues = {
  email: "",
};

function ForgotPasswordForm2(props: BoxProps) {
  const router = useRouter();
  const { success } = useAppToast();
  const [requestPasswordChange, { isLoading, error }] =
    useForgotPasswordMutation({});

  return (
    <AppForm<forgotPasswordValues>
      formProps={{
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        justifyContent: "center",
        gap: "1rem",
        mt: "1.5rem",
        ...props,
      }}
      apiError={(error && parseApiError(error)) || null}
      initialValues={initialValues}
      validationSchema={forgotPasswordFormValidationSchema}
      onSubmit={(values) => {
        requestPasswordChange(values)
          .unwrap()
          .then((res) => {
            if (res?.data) {
              success(isString(res.data) ? res?.data : res?.data?.message);
              router.push("/login");
            }
          });
      }}
    >
      <FormField
        name="email"
        border={"1px solid #E2F4FF"}
        rounded={"50px"}
        placeholder={"Enter your email address"}
        backgroundColor="#FFFFFF"
        padding={"25px"}
      />

      <Button
        isLoading={isLoading || false}
        isDisabled={isLoading || false}
        mt="1rem"
        w="full"
        type="submit"
      >
        Continue
      </Button>
      <Flex
        display={{
          base: "none",
          md: "flex",
        }}
        w="full"
        flexDirection="column"
      >
        <Divider my="1rem" />
        <Text mx="auto" fontWeight={500}>
          <Link
            href="/login"
            color="primary.500"
            _hover={{
              color: "primary.700",
            }}
          >
            Return to login
          </Link>
        </Text>
      </Flex>
    </AppForm>
  );
}

export default ForgotPasswordForm2;
